import VectorIcon from './VectorIcon';
import IconProps from './IconProps';

const SearchIcon = ({ width = 24, height = 24 }: IconProps): JSX.Element => (
  <VectorIcon width={width} height={height}>
    <path
      d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 
      11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
      stroke="#0D2E68"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 21L16.65 16.65"
      stroke="#0D2E68"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </VectorIcon>
);

export default SearchIcon;
